export const accessTypes = {
    loading: "LOADING_ACCESS",
    delete: "DELETE_ACCESS",
    loadedOne: "LOADED_ACCESS",
    loadedMultiple: "LOADED_ACCESSS",
    success: "SUCCESS_ACCESS",
    restore: "RESTORE_ACCESS",
    hardDelete: "HARDDELETE_ACCESS",
};
